import { FC } from "react";
import { Box } from "@mui/material";
import { TEAM_DATA } from "./data";
import TeamMember from "../TeamMember";

interface Props {
  inMobile: boolean;
}

const Team: FC<Props> = ({ inMobile }) => {
  return (
    <Box>
      {TEAM_DATA.map((data) => (
        <TeamMember key={data.id} {...data} inMobile={inMobile} />
      ))}
    </Box>
  );
};

export default Team;
